export default function rehydrate<T>(
	obj: Partial<T>,
	constructor: Constructable<T> | Function
) {
	Object.setPrototypeOf(obj, constructor.prototype)

	return obj as T
}
